/**
 * Merge a getProfile payload into the stored user without silently moving
 * the active club back to the user's home / DB club.
 *
 * Club switching (especially guest context) keeps the UI club on localStorage
 * while tbl_user.club_id may still be the home club. Profile refreshes must
 * not overwrite that selection.
 */
export function mergeProfilePreservingActiveClub(storedUser, profileUser) {
  const stored =
    storedUser && typeof storedUser === "object" ? { ...storedUser } : {};
  const profile =
    profileUser && typeof profileUser === "object" ? profileUser : {};

  const activeClubId = String(
    stored.club_id || stored.club_details?.club_id || stored.club?.club_id || ""
  ).trim();
  const profileClubId = String(
    profile.club_id ||
      profile.club_details?.club_id ||
      profile.club?.club_id ||
      ""
  ).trim();

  const merged = { ...stored, ...profile };

  if (activeClubId && profileClubId && activeClubId !== profileClubId) {
    merged.club_id = activeClubId;
    if (stored.club_details) merged.club_details = stored.club_details;
    if (stored.club) merged.club = stored.club;
    if (stored.brand_config) merged.brand_config = stored.brand_config;
    if (stored.home_club_id != null) merged.home_club_id = stored.home_club_id;
    if (typeof stored.guest_context === "boolean") {
      merged.guest_context = stored.guest_context;
    }
    // Role flags are club-scoped after switchClub — keep the active club's.
    for (const key of [
      "hasAdminRole",
      "hasCoachRole",
      "hasPlayerRole",
      "hasModeratorRole",
      "hasGuestPlayerRole",
      "hasCommitteeRole",
      "hasMonitorRole",
      "membership_kind",
    ]) {
      if (key in stored) merged[key] = stored[key];
    }
  }

  return merged;
}
